import * as React from "react";

import Button from "@material-ui/core/Button";
import { DetailActionProps, getNextPage } from "../detail-actions-props";
import TrashIcon from "@material-ui/icons/DeleteOutline";
import LoadingIcon from "@material-ui/icons/Timelapse";
import { MessageDialog } from "../message-dialog";
import * as releaseAdmin from "../../../../../sdk/release-admin";
import { useHistory, useLocation } from "react-router";
import { TRASH_KEY } from '../../../../../../.../../../../services/release-admin/types/assignment'
import { handleReleaseDeleted } from "../../../../../utils/rudderstack/events";

export const TrashRelease: React.FC<DetailActionProps> = (props) => {
  const { data } = props;
  const history = useHistory();
  const location = useLocation<{from?: string}>();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleTrash = async () => {
    setLoading(true);
    setOpen(false);

    await Promise.all(
      data.map(async ({ release, tracks }) => {
        await releaseAdmin.transferRelease(release.id, TRASH_KEY);
        await handleReleaseDeleted({ release, tracks });
      })
    );

    setLoading(false);

    history.push(getNextPage(location.state?.from), location.state);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        endIcon={loading ? <LoadingIcon /> : <TrashIcon />}
        onClick={() => setOpen(true)}
      >
        Trash
      </Button>

      <MessageDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onSend={handleTrash}
        title={`Moving to trash: ${data[0].release.title}`}
        hideMessage
      />
    </>
  );
};
